/*
 * @Author: yinping.che@ginlong.com
 * @Date: 2025-05-29 15:55
 * @LastEditors: 许 文强 wenqiang.xu@ginlong.com
 * @LastEditTime: 2025-07-22 14:20:44
 * @FilePath: \glyun_web_Vue3\src\lang\index.js
 * @Description: xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
 */
import { createI18n } from 'vue-i18n'
import _CONST from '@/const/index'

// import enLocale from './langs/zh-CN'
console.log(getSystemLanguage("string"))
console.log(getSystemLanguage("number"))
// 是否加载完所有的语言
let isLoadedAllLanguage = false
// 默认回退语言，国际en,国内zh
const fallbackLocaleLang = import.meta.env.VITE_ACCESS_TYPE || 'en'
// dayjs.locale("zh")
const i18n = createI18n({
  legacy: false, // 必须为 false（Vue 3 专用）
  locale: getSystemLanguage("string"), // 默认语言
  fallbackLocale: fallbackLocaleLang, // 回退语言
  messages: {
    // 语言包
    // en: {
    //   ...enLocale,
    // },
  },
  // v11 新增配置
  autoInstallComponents: true, // 自动注册 <i18n-t> 等组件
  globalInjection: true, // 全局注入 $t, $d 等方法
  // useScope: 'global', // 翻译缓存作用域：'global' | 'local' | 'fallback'
  // 警告控制（与 v9 相同）
  silentFallbackWarn: true, // 禁用回退语言警告
  silentTranslationWarn: import.meta.env.VITE_APP_ENV === 'production', // 禁用翻译缺失警告(生产环境禁用翻译警告,开发环境开启)
})
// // 初始化 dayjs 语言环境
// setDayjsLocale();
const loadedLanguages = [] // 我们的预装默认语言
export function setI18nLanguage(lang) {
  i18n.global.locale.value = lang;
  return lang;
}
// 加载单个文件
async function loadSingleLangugeFile(lang, localeFiles) {
  const messages = await localeFiles[shortToPath[lang]]();
  i18n.global.setLocaleMessage(lang, { ...messages });
  loadedMessagesObj[lang] = messages
  loadedLanguages.push(lang)
}
// 加载所有语言包
async function loadAllLangugeFile({ index, localeFiles, lang }) {
  const fileNameList = Object.keys(_CONST.systemLanguageOptions).filter(item => item !== lang && item !== fallbackLocaleLang)
  const curLanage = fileNameList[index]
  if (!loadedLanguages.includes(curLanage)) {
    await loadSingleLangugeFile(fileNameList[index], localeFiles)
  }
  if (fileNameList[index + 1]) loadAllLangugeFile({ lang: '', index: index + 1, localeFiles })
}
// 已经加载语言包的语言存储对象
const loadedMessagesObj ={}
// 短码 -> 词条文件路径 的映射（zh -> './langs/zh-CN.json'），在 loadLanguageAsync 中由 glob 结果动态生成
let shortToPath = {}
// 动态引入加载文件
export async function loadLanguageAsync(lang) {
  console.log('loadedLanguages',loadedLanguages,lang,i18n.global.messages,loadedMessagesObj)
  // 动态导入所有语言文件（使用 eager: false 实现懒加载）
 const localeFiles = import.meta.glob('./langs/*.json', { eager: false, import: 'default' });
  // 由 glob 结果推导 短码 -> 长码文件路径 映射：'./langs/zh-CN.json' -> zh
  shortToPath = {}
  for (const p of Object.keys(localeFiles)) {
    const base = p.split('/').pop().replace(/\.json$/i, ''); // 'zh-CN'
    shortToPath[base.split('-')[0]] = p;                    // zh -> './langs/zh-CN.json'
  }
  // 如果没有传进来语言,取默认语言
  if (!lang) lang = getLang()
  lang = transformLanguage(lang)
  // 如果语言已经加载
  if (loadedLanguages.includes(lang)) {
    i18n.global.setLocaleMessage(lang, loadedMessagesObj[lang]);
    return Promise.resolve(setI18nLanguage(lang))
  }
  // 如果语言已经加载--加载默认语言包
  const messagesFallbackLocale = await localeFiles[shortToPath[fallbackLocaleLang]]();
  if (!loadedLanguages.includes(fallbackLocaleLang)) {
    loadedLanguages.push(fallbackLocaleLang)
    i18n.global.setLocaleMessage(fallbackLocaleLang, { ...messagesFallbackLocale });
    loadedMessagesObj[fallbackLocaleLang] = messagesFallbackLocale
  }
  // 加载当前语言包
  const messages = await localeFiles[shortToPath[lang]]();
  if (!loadedLanguages.includes(lang)) {
    loadedMessagesObj[lang] = messages
    i18n.global.setLocaleMessage(lang, { ...messages });
    loadedLanguages.push(lang)
  }
  setI18nLanguage(lang);   // 返回并且设置
  // 在语言包加载完之后，将其余包加载一下,同时只加载一个
  // if (!isLoadedAllLanguage) {
  //   isLoadedAllLanguage = true
  //   loadAllLangugeFile({ localeFiles, index: 0, lang })
  // }
}
export default i18n
